import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Box, makeStyles } from '@material-ui/core';
import _ from 'lodash';
import DiaLog from '../Dialog';

const useStyles = makeStyles(() => ({
  content: {
    fontSize: '1.142rem',
    fontFamily: 'NotoSans-Medium',
    fontWeight: 500,
  },
}));

export default function CustomPrompt({
  when,
  cancelAction,
  confirmAction,
  confirmText,
  cancelText,
  titleText,
  contentText,
}) {
  const classes = useStyles();
  const history = useHistory();
  const [showModal, setShowModal] = useState(false);
  const [nextLocation, setNextLocation] = useState(null);
  const [confirmed, setConfirmed] = useState(false);
  const unblockRef = React.useRef(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!when || confirmed) {
      if (unblockRef.current) {
        unblockRef.current();
        unblockRef.current = null;
      }
      return;
    }

    // 拦截路由跳转
    unblockRef.current = history.block((location) => {
      const isSameRoute =
        history.location.pathname === location.pathname &&
        history.location.search === location.search &&
        history.location.hash === location.hash;

      if (isSameRoute) {
        return true;
      }

      setNextLocation(location);
      setShowModal(true); // 显示自定义弹窗
      return false; // 阻止默认跳转
    });

    return () => {
      if (unblockRef.current) {
        unblockRef.current();
        unblockRef.current = null;
      }
    };
  }, [when, confirmed, history]);

  const completeNavigation = () => {
    setLoading(false);
    setConfirmed(true);
    setShowModal(false);

    if (nextLocation) {
      setTimeout(() => {
        history.push(nextLocation);
      }, 0);
      return;
    }

    setNextLocation(null);
  };

  const handleNavigationAction = async (action) => {
    if (_.isFunction(action)) {
      try {
        setLoading(true);
        await action();
      } catch (error) {
        return;
      } finally {
        setLoading(false);
      }
    }

    completeNavigation();
  };

  const handleClose = () => {
    setShowModal(false);
    setNextLocation(null);
  };

  return (
    <DiaLog
      handleClose={handleClose}
      handleCancel={() => handleNavigationAction(cancelAction)}
      title={titleText}
      cancel={cancelText}
      confirm={confirmText}
      handleConfirm={() => handleNavigationAction(confirmAction)}
      disabled={loading}
      dialogfootStyle={{ marginTop: '1rem' }}
      open={showModal}
      width="100%"
      dialogWidth="60%"
      dialogContentStyle={{ overflowY: 'auto' }}
    >
      <Box className={classes.content}>{contentText}</Box>
    </DiaLog>
  );
}
